import React from 'react'

export default function DonorRegister() {
  return(
    <div></div>
  )
}
